module.exports = __webpack_public_path__ + "static/sheepjoghamper-3dace863f915f299430b8a9940072410.jpeg";